import type { AppointmentStatus, Role, Slot } from "@cop/domain";
import { callable } from "./firebase";

export const api = {
  availability: callable<{ serviceId: string; practitionerId?: string; from: string; days: number }, { days: { date: string; slots: Slot[] }[] }>("staffAvailability"),
  hold: callable<{ serviceId: string; practitionerId: string; chairId: string; start: string; idempotencyKey: string }, { holdId: string; expiresAt: string; slot: Slot }>("staffCreateHold"),
  book: callable<
    {
      holdId: string;
      patientId?: string;
      contact?: { firstName: string; lastName: string; phone: string; email?: string; documentId?: string };
      notes?: string;
      status?: "pending_confirmation" | "confirmed";
      idempotencyKey: string;
    },
    { appointmentId: string }
  >("staffCreateBooking"),
  status: callable<{ appointmentId: string; status: AppointmentStatus; reason?: string }, { ok: true }>("updateAppointmentStatus"),
  reschedule: callable<{ appointmentId: string; holdId: string; idempotencyKey: string }, unknown>("rescheduleAppointment"),
  resolveRequest: callable<{ requestId: string; status: "booked" | "dismissed"; appointmentId?: string }, { ok: true }>("resolveRequest"),
  siteStatus: callable<Record<string, never>, { maintenance: boolean; pending: boolean; updatedAt: string | null; updatedBy: string | null }>("siteStatus"),
  setSiteStatus: callable<{ maintenance: boolean }, { maintenance: boolean; pending: boolean }>("setSiteStatus"),
  sitePreviewToken: callable<Record<string, never>, { token: string }>("sitePreviewToken"),
  listStaff: callable<Record<string, never>, { staff: { uid: string; email: string; name: string | null; role: string; updatedAt: string | null }[] }>("listStaff"),
  setStaffRole: callable<{ email: string; role: Role }, { ok: true }>("setStaffRole"),
  revokeStaffRole: callable<{ email: string }, { ok: true }>("revokeStaffRole"),
};

export const key = () => crypto.randomUUID().replace(/-/g, "");
